function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import clsx from 'clsx';
import SovosDrawer from '../sovos-drawer';
import SovosDrawerHeader from '../sovos-drawer-header';
import ButtonsGroup from '../sovos-buttons-group';
import SovosButton from '../sovos-button';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const SovosEditableDrawer = _ref => {
  let {
    children,
    className,
    PrimaryButtonProps = {},
    SecondaryButtonProps = {},
    title,
    ...drawerProps
  } = _ref;
  const {
    t
  } = useMosaicTranslation();
  const {
    children: primaryChildren,
    color: primaryColor,
    className: primaryClassName,
    ...primaryProps
  } = PrimaryButtonProps;
  const {
    children: secondaryChildren,
    color: secondaryColor,
    className: secondaryClassName,
    ...secondaryProps
  } = SecondaryButtonProps;
  return /*#__PURE__*/React.createElement(SovosDrawer, _extends({
    className: clsx('sovosEditableDrawer', className)
  }, drawerProps), /*#__PURE__*/React.createElement(SovosDrawerHeader, {
    title: title
  }, /*#__PURE__*/React.createElement(ButtonsGroup, {
    align: "right"
  }, /*#__PURE__*/React.createElement(SovosButton, _extends({
    className: clsx('SovosDrawerHeader__secondaryButton', secondaryClassName),
    variant: "text"
  }, secondaryProps), secondaryChildren || t('cancel')), /*#__PURE__*/React.createElement(SovosButton, _extends({
    color: primaryColor || 'primary',
    className: clsx('SovosDrawerHeader__primaryButton', primaryClassName)
  }, primaryProps), primaryChildren || t('apply')))), children);
};
SovosEditableDrawer.propTypes = {
  /**
   * The content of the drawer
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Properties for the save button, `onClick` will be required in future versions
   */
  PrimaryButtonProps: shape({
    backgroundColor: string,
    children: node,
    color: string,
    disabled: bool,
    onClick: func,
    style: object,
    className: string
  }),
  /**
   * Properties for the cancel button, `onClick` will be required in future versions
   */
  SecondaryButtonProps: shape({
    backgroundColor: string,
    children: node,
    color: string,
    disabled: bool,
    onClick: func,
    style: object,
    className: string
  }),
  /**
   * Drawer title
   */
  title: node.isRequired
};
SovosEditableDrawer.baseComponent = {
  name: 'SovosDrawer'
};
export default SovosEditableDrawer;